import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'



import '@/assets/css/modern.css'
// import '@/assets/js/settings'
import '@/assets/js/app'

import '@/assets/css/base.css'

import ApiService from '@/assets/js/apiService'; // 引入 ApiService 實例
import Parameters from '@/assets/js/parameters'
import shareds from '@/assets/js/shared'



// 創建 ApiService 實例並將 router 傳遞給它
const apiService = new ApiService(router);
const parameters = new Parameters()
const shared = new shareds()

const app = createApp(App);

app.config.globalProperties.$api = apiService;
app.config.globalProperties.$parameters = parameters;
app.config.globalProperties.$shared = shared;

import packageJson from '../package.json'
app.config.globalProperties.$version = process.env.VUE_APP_ENV_NAME === 'production' ? packageJson.version : `${process.env.VUE_APP_ENV_NAME}.${packageJson.version}`
console.log(`version=${app.config.globalProperties.$version}`)

app
.use(i18n)
.use(store)
.use(router)

router.isReady().then(() => {
    app.mount('#app'); // 確保路由就緒後再掛載應用
});
